import { IBaseIconProps } from "./IBaseIconProps";

export const EditIcon = ({
  color = "#fff",
  backgroundColor,
}: IBaseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-5.0 -10.0 110.0 135.0"
      fill={color}
    >
      <path d="m64.129 13.188 22.66 22.574-54.77 54.766-22.57-22.57zm-61.582 81.367c-0.11328 0.80078 0.16016 1.6094 0.73828 2.1758 0.5625 0.58594 1.375 0.85938 2.1758 0.73828l19.023-2.1758-19.781-19.828zm92.055-80.191-9.0547-9.0547c-3.7148-3.7344-9.75-3.75-13.484-0.035156-0.011719 0.011718-0.023438 0.023437-0.035156 0.035156l-1.7188 1.7188 22.637 22.574 1.7188-1.7188c3.7344-3.7148 3.75-9.75 0.035157-13.484l-0.035157-0.035157z" />
    </svg>
  );
};
